import {Cart, ICartPosition} from "@connox/typescript-library";
import * as React from "react";
import {useCartContext} from "../CartContextProvider/CartContextProvider";
import ItemRow from "./ItemRow";
import {getShopId} from "../../lib/getShopId";
import {useCheckoutContext} from "../../checkout/CheckoutContextProvider/CheckoutContextProvider";
import styles from "./ItemList.module.scss";
import summaryStyles from "../../checkout/steps/Summary/Summary.module.scss";

const ItemList: React.FC<{editable?: boolean; goToCartView?: () => void}> = (props) => {
  const cartTemp = useCartContext().cart;
  let cart: Cart;
  try {
    cart = new Cart(getShopId(), useCheckoutContext().checkout.cartData);
  } catch (err) {
    cart = cartTemp;
  }

  const isRowEditable = props.editable === undefined ? true : props.editable;

  const itemPositions = cart.positions.filter((pos) => pos.reference && pos.reference.itemId !== null);

  if (!itemPositions.length) {
    return null;
  }

  const fixVouchers = cart.positions.filter<ICartPosition>(
    (pos: ICartPosition): pos is ICartPosition => pos.type === "Voucher" && pos.reference?.voucher?.type === "Fix",
  );

  const relativeVouchers = cart.positions.filter<ICartPosition>(
    (pos: ICartPosition): pos is ICartPosition => pos.type === "Voucher" && pos.reference?.voucher?.type === "Relative",
  );

  return (
    <React.Fragment>
      {props.goToCartView && (
        <span className={summaryStyles.pen} onClick={props.goToCartView}>
          <span className="Svg Svg-Icon-Pen">&#160;</span>
        </span>
      )}
      <div>
        <div className={`${styles.itemList} ArrowBorder`}>
          {itemPositions.map((position) => (
            <ItemRow
              editable={isRowEditable}
              fixVouchers={fixVouchers}
              position={position}
              relativeVouchers={relativeVouchers}
              key={`ItemRow${position.item ? position.item.itemId : position.text}`}
            />
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ItemList;
